module.exports = require("./../../_gen/openfl/net/URLRequestDefaults");